


































































































import { Prop, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import L, { Marker } from 'leaflet';
import { LMap, LMarker, LTileLayer } from 'vue2-leaflet';
import Map2dService from '@/entities/map-2-d/map-2-d.service';
import { IMap2d } from '@/shared/model/map-2-d.model';
import PlanningService from '@/entities/planning/planning.service';

import LDrawToolbar from 'vue2-leaflet-draw-toolbar';
import Vr360Service from '@/entities/vr-360/vr-360.service';
import Vr360Viewer from '@/custom/page/filemanager/map/Vr360Viewer.vue';
import { mobileFullScreenStyle } from '@/custom/page/filemanager/map/mobile-viewer-style';

@Component({ components: { LMap, LTileLayer, LMarker, LDrawToolbar, Vr360Viewer } })
export default class Map2DViewer extends Vue {
  center = [35.5, -95.5];
  bounds = null;

  ggMapTypes = [
    { key: 'm', name: 'Giao thông tiêu chuẩn' },
    { key: 's', name: 'Chỉ vệ tinh' },
    { key: 'y', name: 'Giao thông + Vệ tinh' },
    // { key: 'h', name: 'Chỉ đường phố' },
    // { key: "p", name: "Terrain" },
    // { key: "r", name: "Somehow Altered Roadmap" },
    // { key: "t", name: "Terrain Only" },
  ];
  selectGGMapType = 'm';

  map = null;

  baseUrl = `https://mt0.google.com/vt/lyrs=m&hl=vi&x={x}&y={y}&z={z}`;
  baseUrlTileLayer = null;
  map2dTileLayer = null;

  geoJsonLayer = null;
  showGeoJsonLayer = true;

  vr360List = [];
  vr360Dialog = {
    open: false,
    id: null,
  };

  @Prop() mobileMode: boolean;
  accessToken = '';
  // Lỗi khi tải bản đồ. Trước đây lỗi làm trang trắng trơn mà không báo gì.
  loadError = '';
  // baseUrl = "https://mt0.google.com/vt/lyrs=m&hl=vi&x={x}&y={y}&z={z}";
  zoom = 17;
  vr360Page = {
    page: 0,
    size: 999999,
  };
  style = {};
  map2d: IMap2d = {};

  get id() {
    return parseInt(this.$route.params.map2dId);
  }

  get map2dTileUrl() {
    if (!this.mobileMode) {
      let map2dService = new Map2dService();
      return map2dService.tileUrl(this.id);
    } else {
      let map2dService = new Map2dService();
      return map2dService.tileUrlMobile(this.id, this.accessToken);
    }
    // map2dService.find(this.id)
    // if (this.map2d) {
    //   let url = `http://localhost:8540/tile?x={x}&y={y}&z={z}&mbtilesFilePath=${this.map2d.mbtilesFilePath}`;
    //   //   console.log(url)
    //   return url;
    // }
    // return '';
    // return `http://localhost:8540/tile?x={x}&y={y}&z={z}&mbtilesFilePath=C:/Users/HienHoang/Downloads/qgis_data/caudoi2.mbtiles`
  }

  formatDate(date) {
    let s = date + '';
    date = s.substring(0, s.indexOf('T'));
    date = date.split('-');
    date = date[2] + '/' + date[1] + '/' + date[0];
    return date;
  }

  @Watch('selectGGMapType')
  updateBaseUrl(val, oldVal) {
    this.baseUrl = `https://mt0.google.com/vt/lyrs=${this.selectGGMapType}&hl=vi&x={x}&y={y}&z={z}`;
    if (this.baseUrlTileLayer && this.map) {
      this.map.removeLayer(this.baseUrlTileLayer);
      this.baseUrlTileLayer = L.tileLayer(this.baseUrl, {
        maxZoom: 22,
        maxNativeZoom: 22,
      });
      this.baseUrlTileLayer.addTo(this.map);
      if (this.map2dTileLayer) {
        this.map2dTileLayer.bringToFront();
      }
      if (this.geoJsonLayer) {
        this.geoJsonLayer.bringToFront();
      }
    }
    localStorage.setItem('selectGGMapType', this.selectGGMapType);
  }

  createSegmentTooltip(layer) {
    if (layer.segmentTooltips && layer.segmentTooltips.length) {
      return;
    }

    layer.segmentTooltips = [];
    for (let i = 0; i < layer.getLatLngs().length - 1; i++) {
      layer.segmentTooltips.push(
        L.tooltip({
          permanent: true,
          direction: 'center',
          className: 'segment-tooltip',
        })
      );
    }

    layer.on('remove', function (event) {
      layer.segmentTooltips.forEach(e => e.remove());
    });

    const parent = this;
    layer.on('add', function (event) {
      parent.updateSegmentTooltip(layer);
      layer.segmentTooltips.forEach(e => e.addTo(parent.map));
    });

    if (this.map.hasLayer(layer)) {
      this.updateSegmentTooltip(layer);
      layer.segmentTooltips.forEach(e => e.addTo(parent.map));
    }
  }

  updateSegmentTooltip(layer) {
    let latLngs = layer.getLatLngs();
    for (let i = 0; i < latLngs.length - 1; i++) {
      let center = new L.LatLng((latLngs[i].lat + latLngs[i + 1].lat) / 2, (latLngs[i].lng + latLngs[i + 1].lng) / 2);
      const length = layer.getLatLngs()[i].distanceTo(layer.getLatLngs()[i + 1]);
      const readableDistance = L.GeometryUtil.readableDistance(length, ['km']);

      layer.segmentTooltips[i].setContent(readableDistance).setLatLng(center);
    }
  }

  createAreaTooltip(layer) {
    if (layer.areaTooltip) {
      return;
    }

    layer.areaTooltip = L.tooltip({
      permanent: true,
      direction: 'center',
      className: 'area-tooltip',
    });

    layer.on('remove', function (event) {
      layer.areaTooltip.remove();
    });

    const parent = this;
    layer.on('add', function (event) {
      parent.updateAreaTooltip(layer);
      layer.areaTooltip.addTo(parent.map);
    });

    if (this.map.hasLayer(layer)) {
      this.updateAreaTooltip(layer);
      layer.areaTooltip.addTo(this.map);
    }
  }

  updateAreaTooltip(layer) {
    let area;
    let latlng;
    if (layer instanceof L.Circle) {
      area = layer.getRadius() * layer.getRadius() * 3.141592654; // radius
      latlng = layer.getLatLng();
    } else {
      area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
      latlng = layer.getCenter();
    }
    const readableArea = L.GeometryUtil.readableArea(area, ['km']);

    layer.areaTooltip.setContent(readableArea).setLatLng(latlng);
  }

  mounted() {
    // Đã chuyển định nghĩa proj4 ra ngoài nên không cần ở đây nữa
    if (this.mobileMode) {
      this.accessToken = this.$route.query.accessToken as string;
      this.style = mobileFullScreenStyle();
    }
    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    this.selectGGMapType = localStorage.getItem('selectGGMapType') || 'm';
    let map2dService = new Map2dService();
    let map2dPromise: Promise<IMap2d>;
    if (!this.mobileMode) {
      map2dPromise = map2dService.find(this.id);
    } else {
      map2dPromise = map2dService.findByMobileApi(this.id, this.accessToken);
    }
    const mapReady = map2dPromise.then(async rs => {
      this.map2d = rs;
      this.zoom = this.map2d.defaultZoom || this.zoom;
      await this.fetchVr360();

      this.map = L.map('map2d').setView([this.map2d.defaultPosLat, this.map2d.defaultPosLng], this.zoom);
      this.baseUrlTileLayer = L.tileLayer(this.baseUrl, {
        maxZoom: 22,
        maxNativeZoom: 22,
      });
      this.baseUrlTileLayer.addTo(this.map);

      // Mở lại map2D layer
      this.map2dTileLayer = L.tileLayer(this.map2dTileUrl, {
        maxZoom: 22,
        maxNativeZoom: 22,
        opacity: 1,
      });
      this.map2dTileLayer.addTo(this.map);

      const drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      const drawControl = new L.Control.Draw({
        edit: {
          featureGroup: drawnItems,
          poly: {
            allowIntersection: false,
          },
        },
        draw: {
          polygon: {
            allowIntersection: false,
            showArea: true,
            showLength: true,
            metric: ['km'],
          },
          rectangle: {
            showArea: true,
            metric: ['km'],
          },
          circle: {
            showArea: true,
            metric: ['km'],
          },
          circlemarker: false,
        },
      });
      const parent = this;
      this.map.addControl(drawControl);
      this.map.on(L.Draw.Event.CREATED, function (event) {
        const layer = event.layer;
        if (layer instanceof L.Polygon || layer instanceof L.Circle || layer instanceof L.Rectangle) {
          parent.createAreaTooltip(layer);
        } else if (layer instanceof L.Polyline) {
          parent.createSegmentTooltip(layer);
        }
        drawnItems.addLayer(layer);
      });

      this.map.on(L.Draw.Event.EDITED, function (event) {
        event.layers.getLayers().forEach(function (layer) {
          if (layer instanceof L.Polygon || layer instanceof L.Circle || layer instanceof L.Rectangle) {
            parent.updateAreaTooltip(layer);
          } else if (layer instanceof L.Polyline) {
            parent.updateSegmentTooltip(layer);
          }
        });
      });
      const icon360Scale = 3.8;
      const icon360Size = {
        width: 136 / (icon360Scale * 1.1),
        height: 161 / icon360Scale,
      };
      const icon360 = L.icon({
        iconUrl: 'content/images/map/360icon.png',
        iconSize: [icon360Size.width, icon360Size.height],
        iconAnchor: [icon360Size.width / 2, icon360Size.height],
        popupAnchor: [0, 0],
      });
      const centerScale = 18;
      const centerIconSize = {
        width: 534 / centerScale,
        height: 800 / centerScale,
      };
      const centerIcon = L.icon({
        iconUrl: 'content/images/map/center.png',
        iconSize: [centerIconSize.width, centerIconSize.height],
        iconAnchor: [centerIconSize.width / 2, centerIconSize.height],
        popupAnchor: [0, 0],
      });
      const vr360Markers = [];
      this.vr360List
        .filter(vr360 => !!vr360.defaultPosLat && !!vr360.defaultPosLng)
        .filter(vr360 => vr360.flightDate === this.map2d.flightDate)
        .forEach(vr360 => {
          vr360Markers.push(
            L.marker([vr360.defaultPosLat, vr360.defaultPosLng], {
              icon: icon360,
              zIndexOffset: 2000,
            }).on('click', () => {
              this.vr360Dialog = {
                open: true,
                id: vr360.id,
              };
            })
          );
        });
      const centerMarker = L.marker([this.map2d.defaultPosLat, this.map2d.defaultPosLng], { icon: centerIcon })
        .on('click', () => {
          this.reload();
        })
        .setZIndexOffset(1000);
      const parentThis = this;
      if (this.map.getZoom() < 15) {
        this.showOnLowZoom(parentThis, centerMarker, vr360Markers);
      } else {
        this.showOnHighZoom(parentThis, centerMarker, vr360Markers);
      }
      this.map.on('zoomend', function () {
        if (parentThis.map.getZoom() < 15) {
          parentThis.showOnLowZoom(parentThis, centerMarker, vr360Markers);
        } else {
          parentThis.showOnHighZoom(parentThis, centerMarker, vr360Markers);
        }
      });

      // Tự động load file polygon.geojson
      this.loadPlanningGeoJson();
    });
    mapReady.catch(err => {
      console.error('Không tải được bản đồ 2D:', err);
      this.loadError = this.describeLoadError(err);
    });
  }

  private describeLoadError(err: any): string {
    const status = err?.response?.status;
    if (this.mobileMode && (status === 401 || status === 403)) {
      return 'Phiên truy cập đã hết hạn hoặc tài khoản chưa được cấp quyền xem bản đồ trên mobile. Vui lòng mở lại từ ứng dụng.';
    }
    if (status === 400 && err?.response?.data?.errorKey === 'permission') {
      return 'Tài khoản không có quyền xem bản đồ của dự án này.';
    }
    if (status === 404) {
      return 'Không tìm thấy bản đồ.';
    }
    return `Không tải được bản đồ${status ? ` (mã lỗi ${status})` : ''}. Vui lòng thử lại.`;
  }

  // Tự động load file polygon.geojson từ API
  async loadPlanningGeoJson() {
    if (!this.map2d.project || !this.map2d.project.id) {
      console.log('Bản đồ này không có thông tin dự án.');
      return;
    }
    const projectId = this.map2d.project.id;
    const planningService = new PlanningService();
    try {
      const geoJsonData = this.mobileMode
        ? await planningService.getPlanningFileMobileApi(projectId, this.accessToken)
        : await planningService.getPlanningFile(projectId);
      this.addGeoJsonLayer(geoJsonData);
      console.log(`Đã load thành công file quy hoạch cho dự án id ${projectId}`);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log('Không tìm thấy file quy hoạch cho dự án này.');
      } else {
        console.error('Lỗi khi tải file quy hoạch:', error);
      }
    }
  }

  reload() {
    if (this.map) {
      this.map.setView([this.map2d.defaultPosLat, this.map2d.defaultPosLng], this.zoom);
    }
  }

  addGeoJsonLayer(geoJsonData) {
    if (this.geoJsonLayer) {
      this.map.removeLayer(this.geoJsonLayer);
    }

    console.log('Adding GeoJSON layer with standard L.geoJSON...');

    // Sử dụng L.geoJSON gốc của Leaflet vì file đã ở định dạng EPSG:4326
    this.geoJsonLayer = L.geoJSON(geoJsonData, {
      style: feature => {
        // Ghi lại thuộc tính của feature ra console để dễ dàng debug
        console.log('Đang áp dụng style cho feature:', feature.properties);

        const layerName = feature.properties?.Layer;

        switch (layerName) {
          case 'TUAN VAT LIEU':
            return { color: '#A0522D', weight: 1, fillOpacity: 0.5 }; // Brown
          case 'Qh-HAnhchinh':
            return { color: '#800080', weight: 1, fillOpacity: 0.3 }; // Purple
          case '0':
            return { color: '#808080', weight: 1, fillOpacity: 0.2 }; // Gray
          case '11-DAT CAY XANH CACH LY_ QH':
            return { color: '#228B22', weight: 1, fillOpacity: 0.4 }; // Forest Green
          case 'LAYER30':
            return { color: '#0000FF', weight: 1, fillOpacity: 0.3 }; // Blue
          case 'LAYER54':
            return { color: '#FFFF00', weight: 1, fillOpacity: 0.3 }; // Yellow
          case '@ nuoc':
            return { color: '#00BFFF', weight: 1, fillOpacity: 0.6 }; // Deep Sky Blue
          case '@ dat o lang xom ht':
            return { color: '#FFA500', weight: 1, fillOpacity: 0.4 }; // Orange
          case '3- hach nong nghiep':
            return { color: '#90EE90', weight: 1, fillOpacity: 0.5 }; // Light Green
          case 'doi nui':
            return { color: '#808000', weight: 1, fillOpacity: 0.5 }; // Olive
          case 'DVTM':
            return { color: '#8B0000', weight: 1, fillOpacity: 0.5 }; // Đỏ đậm
          default:
            // Style mặc định nếu không khớp
            return { color: '#ff0000', weight: 1, fillOpacity: 0.2 };
        }
      },
      onEachFeature: (feature, layer) => {
        const properties = feature.properties || {};
        let popupContent = '<div>';
        Object.keys(properties).forEach(key => {
          popupContent += `<strong>${key}:</strong> ${properties[key]}<br>`;
        });
        popupContent += '</div>';
        layer.bindPopup(popupContent || 'GeoJSON Feature');
      },
    });

    // Thêm layer vào map
    this.geoJsonLayer.addTo(this.map);
    console.log('GeoJSON layer added to map:', this.geoJsonLayer);

    if (this.geoJsonLayer) {
      // Đưa GeoJSON layer lên trên cùng
      this.geoJsonLayer.bringToFront();

      const bounds = this.geoJsonLayer.getBounds();
      console.log('GeoJSON layer bounds:', bounds);

      if (bounds.isValid()) {
        console.log('GeoJSON bounds is valid');
        console.log('Southwest:', bounds.getSouthWest());
        console.log('Northeast:', bounds.getNorthEast());
        console.log('Center:', bounds.getCenter());

        const mapCenter = this.map.getCenter();
        const mapZoom = this.map.getZoom();
        console.log('Current map center:', mapCenter);
        console.log('Current map zoom:', mapZoom);

        // Tính toán khoảng cách từ map center đến GeoJSON center
        const distance = mapCenter.distanceTo(bounds.getCenter());
        console.log('Distance from map center to GeoJSON center (meters):', distance);

        // Kiểm tra xem bounds có overlap không
        const mapBounds = this.map.getBounds();
        const overlaps = mapBounds.overlaps(bounds);
        console.log('Bounds overlap với map hiện tại?', overlaps);

        // Zoom to GeoJSON bounds với animation
        console.log('Fitting map to GeoJSON bounds...');
        this.map.fitBounds(bounds, {
          padding: [20, 20],
          maxZoom: 18,
          animate: true,
          duration: 1,
        });

        // Log lại sau khi zoom
        setTimeout(() => {
          console.log('After fitBounds - Map center:', this.map.getCenter());
          console.log('After fitBounds - Map zoom:', this.map.getZoom());
          console.log('After fitBounds - Map bounds:', this.map.getBounds());
        }, 1500);
      } else {
        console.error('GeoJSON bounds is not valid!');
        console.log('Trying to zoom to map center with higher zoom level...');
        this.map.setView([this.map2d.defaultPosLat, this.map2d.defaultPosLng], 16);
      }
    }
  }

  toggleGeoJsonLayer() {
    if (this.geoJsonLayer) {
      if (this.showGeoJsonLayer) {
        this.geoJsonLayer.addTo(this.map);
      } else {
        this.map.removeLayer(this.geoJsonLayer);
      }
    }
  }

  private async fetchVr360() {
    // VR360 chỉ là lớp phụ. mounted() await hàm này trước khi tạo L.map, nên trước đây request
    // VR360 lỗi là cả trang trắng — lỗi ở đây phải nuốt lại để bản đồ vẫn hiện.
    try {
      if (!this.mobileMode) {
        let vr360ListRS = await new Vr360Service().findByProjectId(this.map2d.project.id, this.vr360Page);
        this.vr360List = vr360ListRS.data;
      } else {
        let vr360ListRS = await new Vr360Service().findByProjectIdMobileApi(this.accessToken, this.map2d.project.id, this.vr360Page);
        this.vr360List = vr360ListRS.data;
      }
    } catch (err) {
      console.error('Không tải được danh sách VR360, vẫn hiển thị bản đồ:', err);
      this.vr360List = [];
    }
  }

  private showOnHighZoom(parentThis: this, centerMarker: Marker<any>, vr360Markers: any[]) {
    parentThis.map.removeLayer(centerMarker);
    vr360Markers.forEach(marker => {
      parentThis.map.addLayer(marker);
    });
  }

  private showOnLowZoom(parentThis: this, centerMarker: Marker<any>, vr360Markers: any[]) {
    parentThis.map.addLayer(centerMarker);
    vr360Markers.forEach(marker => {
      parentThis.map.removeLayer(marker);
    });
  }
}
